import { FC, PropsWithChildren } from 'react';

import { MembershipWithOrganizationTypeEnum } from '@/api/rest/resources/types/membership';
import { SecondaryNav } from '@/components';
import { usePlotGroupId } from '@/components/PlotGroups/PlotGroupsContextProvider';
import { useMembershipType } from '@/hooks/useMembershipType';
import { SignedInPageLayoutContentContainer } from '@/layout/signed-in-page/components';
import { useProjectId } from '@/pages/shared/hooks/useProjectId';
import { StackedPageLayout } from '@/pages/shared/layout/StackedPage.layout';
import { paths } from '@/routing';
import { buildPath } from '@/utils/buildPath';

interface LandMonitoringPageWrapperProps {
  title: string;
}

export const LandMonitoringProjectPageWrapper: FC<PropsWithChildren<LandMonitoringPageWrapperProps>> = ({
  title,
  children,
}) => {
  const membershipType = useMembershipType();
  const projectId = useProjectId();

  return (
    <StackedPageLayout withCustomContentContainer>
      <SecondaryNav
        backPath={buildPath(
          membershipType === MembershipWithOrganizationTypeEnum.land_steward
            ? paths.landSteward.projectDetails
            : paths.buyer.projectDetails,
          { pathParams: { projectId } },
        )}
        title={title}
      />
      <SignedInPageLayoutContentContainer>{children}</SignedInPageLayoutContentContainer>
    </StackedPageLayout>
  );
};

export const LandMonitoringDetailPageWrapper: FC<PropsWithChildren<LandMonitoringPageWrapperProps>> = ({
  title,
  children,
}) => {
  const membershipType = useMembershipType();
  const plotGroupId = usePlotGroupId();

  return (
    <StackedPageLayout withCustomContentContainer>
      <SecondaryNav
        backPath={buildPath(
          membershipType === MembershipWithOrganizationTypeEnum.land_steward
            ? paths.landSteward.details
            : paths.buyer.details,
          { queryParams: { plotGroupId } },
        )}
        title={title}
      />
      <SignedInPageLayoutContentContainer>{children}</SignedInPageLayoutContentContainer>
    </StackedPageLayout>
  );
};
